import { initializeApp, } from 'firebase/app';
import { defineNuxtPlugin, useRuntimeConfig, } from 'nuxt/app';
import { getMessaging, } from 'firebase/messaging';

// Checking the User-Agent because firebase doesn't play well with some in-app browsers like facebook/instagram
function isRestrictedInAppBrowser(userAgentString) {
  if (!userAgentString) {
    return false;
  }
  const ua = userAgentString.toLowerCase();

  /******* THESE CAN CHANGE OVER TIME, check user agents if service worker failure on in app browsers *******/
  const isInstagram = ua.includes('instagram');
  const isFacebook = ua.includes('fbios') || ua.includes('fbav'); // Common Facebook app identifiers

  return isInstagram || isFacebook;
}

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();

  const app = initializeApp(config.public.firebase.config);
  let messaging = null;

  let userAgent;

  // Access User-Agent on the server
  if (import.meta.server) {
    // Ensuring ssrContext and event are available from Nuxt with Nitro/h3.
    if (nuxtApp.ssrContext && nuxtApp.ssrContext.event && nuxtApp.ssrContext.event.node && nuxtApp.ssrContext.event.node.req && nuxtApp.ssrContext.event.node.req.headers) {
      userAgent = nuxtApp.ssrContext.event.node.req.headers['user-agent'];
    }
    // Access User-Agent on the client
  } else if (import.meta.client) {
    userAgent = navigator.userAgent;
  }

  if (isRestrictedInAppBrowser(userAgent)) {
    console.warn(
      'Firebase Messaging: Detected a restricted in-app browser. Messaging might be disabled or limited.'
    );
  } else if (import.meta.client) {
    try {
      messaging = getMessaging(app);
    } catch (e) {
      console.error('Error initializing Firebase Messaging:', e);
    }
  }

  nuxtApp.vueApp.provide('messaging', messaging);
  nuxtApp.provide('messaging', messaging);
});
